import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { VideoPlacementValues } from '../../../common/model/type/video-placement.types';
import {
  findPlacement,
  getPlacementVisibility,
} from '../../../common/utils/video-placement-utils';
import { useAudienceLabel } from '../../../hooks/use-audience-label';
import { useVideoPlacements } from '../../../hooks/use-video-placements';

interface OvStagedPlacementSummaryProps {
  values: VideoPlacementValues;
}

const OvStagedPlacementSummary: FC<OvStagedPlacementSummaryProps> = ({
  values,
}) => {
  const { t } = useTranslation();
  const placements = useVideoPlacements();
  const getAudienceLabel = useAudienceLabel();
  const visibility = getPlacementVisibility(values);

  switch (visibility.kind) {
    case 'notShown':
      return <>{t('videos.placement.notShown')}</>;

    case 'everyone':
    case 'goals': {
      const placement = findPlacement(
        placements.data ?? [],
        values.placement_key
      );

      return (
        <>
          {t('videos.staging.placementSummary', {
            placement: placement?.description ?? values.placement_key,
            position: values.position,
            audience: getAudienceLabel(values.health_goals),
          })}
        </>
      );
    }

    default: {
      const unhandledVisibility: never = visibility;

      return unhandledVisibility;
    }
  }
};

export default OvStagedPlacementSummary;
